<template>
  <div class="content al_c">

    <s-location title="로그인" hide-subtitle />

    <div class="login_wrap">
      <!-- <h3><span class="pc">서울지방변호사회 </span> <p>수임사건 경유업무 시스템</p> </h3> -->
      <h3><span class="pc">서울지방변호사회 </span> <p>수임사건 경유업무 시스템</p> </h3>
      <input v-model="login.id" ref="id" type="text" title="아이디 입력" 	placeholder="아이디 입력" name="kwd"   id="topKwd" class="tplaceholder" :rules="[rules.alphabet, rules.min]" />
      <input v-model="login.pw"          type="password" title="비밀번호 입력" placeholder="비밀번호 입력" name="kwd" id="topKwd" class="tplaceholder" @keydown.enter="doLogin" :rules="[rules.min]" />
      <input type="checkbox" name="saveId" value="1"><label for="save" class="checkbox">아이디저장</label>
      <div class="btn xl blue01" @click="doLogin">로그인</div>
      <div class="info_user">
        <router-link to="/member/join" class="left">회원가입</router-link>
        <!-- <a href="" class="right">아이디/비밀번호 찾기</a> -->
      </div>
    </div>

    <div class="comment dot_gray bg_gray  expcomment">
      <p class="tit"> 안내</p>
      <li>경유 홈페이지가 리뉴얼됨에 따라 별도의 회원가입을 해야 하는 번거로움을 해소하기 위해 개인회원의 경우 본회 홈페이지 (<a href="https://www.seoulbar.or.kr" target="_blank" class="blue01 uline">https://www.seoulbar.or.kr</a>) 에 가입된 아이디로 통합하였습니다. 따라서, 개인회원의 경우에는 본회 홈페이지에 가입된 아이디와는 별개로 예전 경유업무시스템 홈페이지에서 가입하였던 업무전용 아이디가 있을 경우 해당 아이디는 리뉴얼된 홈페이지에서 사용이 불가함을 알려드립니다.</li>
      <li><b class="underline">법무법인, 법무법인(유한)의 경우</b>별도 가입 없이 기존에 사용하던 마스터 계정 아이디와 비밀번호로 로그인이 가능합니다.</li>
      <li>대한변호사협회에 등록 신고된 공동법률사무소의 경우법무법인의 마스터 계정처럼 사용자의 편의를 위해 소속변호사들의 수임사건 내역 등을 통합 관리할 수 있도록 마스터 아이디로 회원가입을 할 수 있도록 하였습니다. 가입을 원할 경우 온라인 경유 홈페이지(https://via.seoulbar.or.kr)에서 회원가입 신청해 주시기 바라며, 관리자가 승인할 경우 사용이 가능합니다.</li>
      <p class="tit"> - 기존회원</p>
      <li>(1) 개인회원 및 법무법인 등 소속변호사 계정: 본회 홈페이지(<a href="https://www.seoulbar.or.kr" target="_blank" class="blue01 uline">https://www.seoulbar.or.kr</a>) 아이디와 비밀번호로 로그인(통합됨)</li>
      <li>(2) 법무법인, 법무법인(유한) 마스터 계정: 기존 경유업무 홈페이지의 아이디와 비밀번호로 로그인</li>
      <p class="tit"> - 신규회원</p>
      <li>(1) 개인회원 및 법무법인 등 소속변호사 계정: 본회 홈페이지 (<a href="https://www.seoulbar.or.kr" target="_blank" class="blue01 uline">https://www.seoulbar.or.kr</a>) 회원가입 후 로그인</li>
      <li>(2) 법무법인, 법무법인(유한), 공동법률사무소 마스터 계정: 온라인 경유 홈페이지(<a href="https://via.seoulbar.or.kr" >https://via.seoulbar.or.kr</a>)에서 가입 신청 및 승인 후 이용 가능</li>
      <div class="box tip">
        <div class="tit mb20">※ 마스터 아이디란?</div>
        개인 아이디와는 별개로 법무법인 등에서 사용할 수 있는 아이디로 소속된 변호사들의 경유증표 구입에서부터 사건내역 입력·수정, 수임액 신고까지 통합관리할 수 있는 아이디를 말합니다.
      </div>
    </div>

  </div>
</template>


<script>
let ui
export default {
  created() {
    ui = this.$ui;
  },
  mounted() {
    // this.$refs.id.$el.getElementsByTagName("input")[0].focus()
    this.$refs.id.focus()
  },
  data() {
    return {
      err_msg: '',
      login: {
        id: '',
        pw: '',
      },
      rules: {
        alphabet : v=> /[a-zA-Z]+/.test(v) || '영문을 포함하여 입력하세요.',
        min: v => v.length >= 3 || '3자 이상 입력하세요.',
      },
      x: [],
      test_login :1,
    }
  },
  watch: {
    err_msg() { // sso 오류메세지 출력
      this.err_msg && ui.alert_error(this.err_msg)
    }
  },
  beforeRouteEnter (to, from, next) {

    if (to && to.query && to.query.mode == 'sso') {

      console.log("to.query = ", to.query);

      // mode: "sso"
      // sso_no: "5"
      // sso_key: "5vjzamz2mcv9tur6blhpocpww9hvyx4rk290hjub5tw4ub96k4"
      T.httpGet("/auth/sso_recv", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/main/main')
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else if (to && to.query && to.query.mode == 'login_switch') {

      console.log("to.query = ", to.query);

      // mode: "login_switch"
      // id: "seoulbar03"
      T.httpGet("/auth/login_switch", to.query,
        ret=>{
          console.log(ret.data)
          if (ret.data) {
            const {status, msg, token, message} = ret.data
            if (status == 'OK') {
              next(vm => {
                vm.$store.commit("session/SET_TOKEN", token) // 로그인 완료 처리
                vm.$router.replace('/') // 메인으로 이동
              })
            } else {
              const err_msg = msg || message // SSO 오류는 msg 에 프로시져 자체 오류는 message 로 넘어온다..
              next(vm => vm['err_msg'] = err_msg) // 오류를 반환했을때
            }
          }
        }, null, v=>next()) // 어떤 경우라도 화면은 나와야 하니깐..

    } else {
      return next()
    }

  // beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //       if(from.path === '/somePath'  && vm.someData.length > 0) {
  //         vm.$router.push({ name: 'some_name'})
  //       } else {
  //         vm.$router.push({ name: 'another_name'})
  //       }
  //     })
  //   },

    // https://router.vuejs.org/kr/guide/advanced/data-fetching.html#%ED%83%90%EC%83%89-%ED%9B%84-%EA%B0%80%EC%A0%B8%EC%98%A4%EA%B8%B0

    // getPost(to.params.id, (err, post) => {
    //   next(vm => vm.setData(err, post))
    // })
    // next()
  },
  methods: {
    mlogin(id, pw) {
      this.login.id = id
      this.login.pw = pw
      this.doLogin()
    },
    doLogin() {

      ui.httpGet('/auth/login', this.login,
        ret => {
          // const {tot_rows, tot_pages, pgsize, page} = ret.data.rs1[0]
          console.log("ret.data", ret.data);
          if (!ret.data)
            return

          // const {status, token, user, msg} = ret.data;
          const {status, token, msg} = ret.data;
          if (status == "OK") {
            console.log("로그인 폼에서 로그인 완료 처리");
            this.$store.commit("session/SET_TOKEN", token);
            this.$router.push(this.$route.query.redirect || '/')
            return
          } else {
            const cmt = T.contains(msg, '가입승인') ? msg : `등록된 아이디가 아니거나 비밀번호가 일치하지 않습니다.

개인 회원 및 소속변호사의 경우, 서울지방변호사회 홈페이지(www.seoulbar.or.kr)에 가입된 아이디와 비밀번호로 로그인 하시기 바라며, 법무법인 마스터 계정의 경우 기존 수임사건 경유업무 홈페이지의 아이디와 비밀번호를 입력해 주시기 바랍니다.`
            ui.alert(cmt, "로그인 실패", {color: 'red', width: 518})
          }

        }, null, v=>this.loading = false)

    }
  },
}
</script>
<style scoped>

  /*-----------------------------------------------------------------------------------------------
    LOGIN :: 로그인
  -------------------------------------------------------------------------------------------------*/
  .login_wrap { display: inline-block; width: 100%; max-width: 480px; margin: 50px auto 20px auto; position:relative; padding: 35px 45px; border: 1px solid #e5e5e5; font-size: 16px; vertical-align: top; box-sizing: border-box; text-align: left; }
  .login_wrap h3 { font-size : 18px;  margin-bottom:40px;}
  .login_wrap h3 p{ color:#064680; margin-top:10px; font-size: 22px;}
  .login_wrap input[type="text"], .login_wrap input[type="password"]{ width: 100%; height: 48px; padding: 11px 70px 11px 11px; font-size:16px; font-weight:700; box-sizing: border-box; background-color: #f3f3f3; margin-bottom:10px; }
  .login_wrap .btn { margin:40px 0 5px 0;}
  .info_user { font-size:13px;}

  .sel_mem li { width:30%; padding: 15px; font-size:14px;}
  .sel_mem li .tit{font-size:15px;}

  .sel_mem li .cont { font-size:14px; font-weight: normal}

  @media screen and (max-width:640px){
    .login_wrap { width:100%; min-width: auto; padding:30px 15px; margin-top:0 !important;}
    .top_m .top_title .header_logo{ display: none !important; }


  }

</style>